import React from 'react';
import Link from '../../../components/LocalizedLink';

const tegevused = {
	'tegevused.yld.pealkiri': 'Activities',
	'tegevused.yld.blokk1': () => (
		<>
			<h2 className='title is-2'>Activities in Varbla Holiday Village</h2>
			<p>
				We have many different activities available for our guests to spend an
				exciting holiday!
			</p>
		</>
	),
	'tegevused.windsurf.pealkiri': 'Windsurf',
	'tegevused.windsurf.kaart.kirjeldus': () => (
		<div>
			<p>Come and discover the world of windsurf!</p>
		</div>
	),
	'tegevused.windsurf.blokk1': () => (
		<>
			<h2 className='title is-2'>Windsurf</h2>
			<p>Come and discover the world of windsurf.</p>
			<p>It is an exciting hobby.</p>
			<p>Excellent way to past time on your summer days.</p>
			<p>
				Varbla is very good place to firt start your training. We have a nice
				sand beach and enough wind for beginners.
			</p>
			<p>
				More information about the surfing
				<a href='http://verpelsurf.wix.com/surfikoolitus'>
					http://verpelsurf.wix.com/surfikoolitus
				</a>
			</p>
		</>
	),
	'tegevused.sup.pealkiri': 'Paddleboarding',
	'tegevused.sup.kaart.kirjeldus': () => (
		<div>
			<p>
				If the sea still calls you, but you are not as extreme to try
				windsurfing then we have a perfect alternative for you.
			</p>
		</div>
	),
	'tegevused.sup.blokk1': () => (
		<div>
			<h2 className='title is-2'>Paddleboarding</h2>
			<p>
				If the sea still calls you, but you are not as extreme to try
				windsurfing then we have a perfect alternative for you. Paddleboarding
				is relaxing activity. You can ride towards the sunset or do some yoga in
				the morning.
			</p>
			<p>At the moment, we can rent out 10 paddleboards.</p>
			<p>
				Rent <strong>25€/3hours, 35€/5hours</strong>
			</p>
		</div>
	),
	'tegevused.pallimangud.pealkiri': 'Sports',
	'tegevused.pallimangud.kaart.kirjeldus': () => (
		<div>
			<p>
				Who likes volleyball, who likes football and who likes to just shoot
				hoops, we have the option to do all of those activities.
			</p>
		</div>
	),
	'tegevused.pallimangud.blokk1': () => (
		<div>
			<h2 className='title is-2'>Sports</h2>
			<p>
				Who likes volleyball, who likes football and who likes to just shoot
				hoops, we have the option to do all of those activities.
			</p>
			<p>
				We have a wide range of activities for everybody. who like playing
				volleyball, football and basketball.
			</p>
		</div>
	),
	'tegevused.baar&piljard.pealkiri': 'Lounge',
	'tegevused.baar&piljard.kaart.kirjeldus': () => (
		<div>
			<p>
				We welcome you to enjoy beautiful sunsets, delicious coctails and
				challenge your friends in a game of pool in our lounge.
			</p>
		</div>
	),
	'tegevused.baar&piljard.blokk1': () => (
		<div>
			<h2 className='title is-2'>Lounge</h2>
			<p>
				We welcome you to enjoy beautiful sunsets, delicious coctails and
				challenge your friends in a game of pool in our lounge.
			</p>
		</div>
	),
	'tegevused.discgolf.pealkiri': 'Discgolf',
	'tegevused.discgolf.kaart.kirjeldus': () => (
		<div>
			<p>
				Brand new discgolf course with 10 fun and exciting courses, through
				sandy beaches and all the way to the lovely junipers.
			</p>
		</div>
	),
	'tegevused.discgolf.blokk1': () => (
		<div>
			<h2 className='title is-2'>Discgolf</h2>
			<p>
				Brand new discgolf course with 10 fun and exciting courses, through
				sandy beaches and all the way to the lovely junipers.
			</p>
		</div>
	),
	'tegevused.saunad.pealkiri': 'Saunas',
	'tegevused.saunad.kaart.kirjeldus': () => (
		<div>
			<p>Take time off and come relax in our two saunas with your buddies.</p>
		</div>
	),
	'tegevused.saunad.blokk1': () => (
		<>
			<h2 className='title is-2'>Saunas</h2>
			<p>
				<strong>Motel sauna</strong>– Next to the Motel, there's a little sauna,
				what you can rent for just to go to the sauna or a little sauna party
				with your friends.
			</p>
			<p>
				On the first floor, there's a homey fireplace room, showers, sauna and a
				bathroom. Theres also 6 beds for 12 guests on the second floor.
			</p>
			<p>The sauna itself can fit 5 persons at a time.</p>
			<p>
				Right next to the sauna, there's a barrel sauna aswell, what you could
				rent for your stay in the sauna.
			</p>
			<p>
				More information available <Link to='/majutus/saunamajad'>here</Link>
			</p>
			<br />
			<p>
				<strong>Juuli & Aadu Sauna</strong>– Perfect place to rest with your
				friends or family just 100 meters from the sand beach.
			</p>
			<p>
				Sauna house has a little kitchen, big living room and a sauna that fits
				10 guest at a time. In front of the house, there's a big terrace and a
				barrel sauna, where you can relax and enjoy your beautiful beach view.
			</p>
			<p>
				The second floor is mostly bedrooms and a bathroom aswell. 4 bedrooms
				with 2 big beds and 6 small beds.
			</p>
			<p>
				More information available <Link to='/majutus/saunamajad'>here</Link>
			</p>
		</>
	),
	'tegevused.paadirent.pealkiri': 'Boat Rent',
	'tegevused.paadirent.kaart.kirjeldus': () => (
		<div>
			<p>Fill your vacation day with a boat ride on the Gulf of Livonia.</p>
		</div>
	),
	'tegevused.paadirent.blokk1': () => (
		<>
			<h2 className='title is-2'>Boat Rent</h2>
			<p>Fill your vacation day with a boat ride on the Gulf of Livonia.</p>
			<p>We have two rowing boats. Boat rent 1hour/ 7€</p>
			<p>
				<strong>
					NB! From the 15th of April to the 30 of June it is not allowed to
					visit the holms, because it's protected area.
				</strong>
			</p>
		</>
	),
	'tegevused.jalgrattarent.pealkiri': 'Bike rent',
	'tegevused.jalgrattarent.kaart.kirjeldus': () => (
		<div>
			<p>A sporty way to discover the lands of Varbla is to rent a bike</p>
		</div>
	),
	'tegevused.jalgrattarent.blokk1': () => (
		<div>
			<h2 className='title is-2'>Bike rent</h2>
			<p>
				A sporty way to discover the lands of Varbla is to rent a bike (8 bikes
				available). Please call and make a reservations!
			</p>
		</div>
	),
	'tegevused.jahindus.pealkiri': 'Hunting',
	'tegevused.jahindus.kaart.kirjeldus': () => (
		<div>
			<p>
				There is a 36 000 hectare area for hunting moose, wild boars, roe deer,
				lynx and wolves.
			</p>
		</div>
	),
	'tegevused.jahindus.blokk1': () => (
		<>
			<h2 className='title is-2'>Hunting</h2>
			<p>
				There is a 36 000 hectare area for hunting moose, wild boars, roe deer,
				lynx and wolves.
			</p>
			<p>
				If you wish to organize a hunting trip, please contact us for more
				information.
			</p>

			<br />
			<p>We hunt:</p>
			<strong>BIG GAME:</strong>
			<ul>
				<li>moose 15.09-30.11</li>
				<li>roe deer 01.06-30.11</li>
				<li>wild boars 01.06-28.02</li>{' '}
				<li>lynx and wolves - only in the case of owning a hunting license.</li>
			</ul>
			<strong>SMALL GAME:</strong>
			<ul>
				<li>beavers 01.08-15.04</li>
			</ul>
			<strong>BIRDS:</strong>
			<ul>
				<li>duck 20.08-30.11</li>
				<li>goose 10.09-30.11</li>
				<li>woodcock 01.10-15.11</li>
			</ul>
			<p>
				To hunt, you need to have the following documents: valid hunting
				license, valid weapon permit. For foreign enthusiasts - shooting test
				certificate (for bigger animals)
			</p>
		</>
	),
	'tegevused.koostoopartnerid.pealkiri': 'Team Games from our partners',
	'tegevused.koostoopartnerid.kaart.kirjeldus': () => (
		<div>
			<p>
				With our partners we arrange different games for your parties all year
				around and in different languages.
			</p>
		</div>
	),
	'tegevused.koostoopartnerid.blokk1': () => (
		<div>
			<h2 className='title is-2'>Team Games from 360 kraadi</h2>
			<p className='is-size-5'>
				360 kraadi organizes team games for your parties all year around and in
				different languages.
			</p>
			<p>ALL GAMES ARE:</p>
			<ul>
				<li>team based</li>
				<li>physical, 2-3h in length</li>
				<li>available in any weather & season</li>
				<li>available in different languages</li>
				<li>available within 2-3 days notice</li>
			</ul>
		</div>
	),
	'tegevused.koostoopartnerid.blokk2': () => (
		<div>
			<h2 className='title is-2'>Seikluspartner</h2>
			<p>
				Seikluspartner offers activities for parties, team events, camping trips
				& much more.
			</p>
		</div>
	),
};

export default tegevused;
